import { NgModule } from '@angular/core';
import { AppPageHeaderComponent } from './app-page-header/app-page-header.component';
import { AppFooterComponent } from './app-footer/app-footer.component';
import { AppHeaderComponent } from './app-header/app-header.component';
import { SharedModule } from '../shared/shared.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from '../core/interceptor/token-interceptor';
import { AuthService } from '../core/services/auth.service';
import { DialogModule } from 'primeng/dialog';
import { CustomMenuItemTooltipDirective } from './directives/custom-menuitem-tooltip.directive';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    AppHeaderComponent,
    AppFooterComponent,
    AppPageHeaderComponent,
    CustomMenuItemTooltipDirective
  ],
  imports: [
    SharedModule,
    DialogModule
  ],
  exports: [
    AppHeaderComponent,
    AppFooterComponent,
    AppPageHeaderComponent
  ],
  providers: [
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    DatePipe
  ],
})

export class CommonModule {

}
